import ParameterValidator from '@mvps-genesis/parameter-validator';

/*
 *--------------------------------------------------------------------------
 * QNA Extension
 *--------------------------------------------------------------------------
 *
 * This class handles Q&A section functionality.
 *
 */

export default class QNA {

	/**
	 * Parameter Validator class object
	 *
	 * @var	@mvps-genesis/parameter-validator	ParameterValidator
	 */
	#validator;

	/**
	 * The root container element
	 *
	 * @var	HTMLElement
	 */
	containerElement;

	/**
	 * The control element to toggle the Q&A form display.
	 *
	 * @var	HTMLElement
	 */
	formToggleControlElement;

	/**
	 * The target element to toggle the Q&A form display.
	 *
	 * @var	HTMLElement
	 */
	formToggleTargetElement;

	/**
	 * The show form attribute name.
	 *
	 * @var	String
	 */
	showFormAttribute;

	/**
	 * Create a new QNA object instance
	 *
	 * @property	HTMLElement	containerElement			The root container element.
	 * @property	HTMLElement	formToggleControlElement	The control element to toggle the Q&A form display.
	 * @property	String		showFormAttribute			The show form attribute name. If the attribute exists on the formToggleControlElement, the Q&A form will be displayed on page load.
	 */
	constructor ({
		containerElement = '.g-product-qna',
		formToggleControlElement = '#js-qna-form-control',
		showFormAttribute = 'data-show-form'
	} = {}) {
		this.#validator = new ParameterValidator(this);
		this.containerElement = this.#validator.isElement('element', containerElement);
		this.formToggleControlElement = this.#validator.isElement('formToggleControlElement', formToggleControlElement, {
			container: this.containerElement,
			required: false
		});

		if (this.formToggleControlElement) {
			this.formToggleTargetElement = this.#validator.isElement('formToggleTargetElement', document.getElementById(this.formToggleControlElement.getAttribute('aria-controls')));
			this.showFormAttribute = this.#validator.isString('showFormAttribute', showFormAttribute);

			this.bindEvents();
		}
	}

	bindEvents () {
		this.formToggleControlElement.addEventListener('click', this.toggleFormContent.bind(this));

		if (this.formToggleControlElement.hasAttribute(this.showFormAttribute)) {
			this.formToggleControlElement.dispatchEvent(new Event('click'));
		}
	}

	toggleFormContent (event) {
		event.preventDefault();

		const contentIsExpanded = this.formToggleControlElement.getAttribute('aria-controls') === 'true';

		if (contentIsExpanded) {
			this.formToggleControlElement.setAttribute('aria-controls', 'false');
			this.formToggleTargetElement.classList.add('u-hidden');
		} else {
			this.formToggleTargetElement.classList.remove('u-hidden');
			this.formToggleControlElement.setAttribute('aria-controls', 'true');
		}
	}
}
